import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';
import HelpTooltip from '../components/HelpTooltip';
import CartCreditBanner from '../components/CartCreditBanner';

export default function Cart() {
console.log('🛒 Cart component rendering');
  const { cartItems, removeFromCart, updateQuantity, getCartTotal, clearCart, getCartSource, cartSource } = useCart();
console.log('📦 Cart items:', cartItems);
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleCheckout = () => {
    navigate('/checkout');
  };

  if (cartItems.length === 0) {
    return (
      <div className="max-w-4xl mx-auto text-center py-12">
        <h1 className="text-3xl font-bold mb-4">Your Cart</h1>
      <CartCreditBanner />
        <div className="bg-white rounded-lg shadow-md p-8">
          <p className="text-gray-500 mb-4">Your cart is empty</p>
          <Link to="/products" className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700">
            Continue Shopping
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold mb-6">Your Cart</h1>
      <CartCreditBanner /> 
      {/* Vendor indicator with full name and link */}
      {cartSource && (
<div className="bg-blue-50 p-3 rounded mb-4 border border-blue-200">
  <p className="text-sm text-blue-700 flex items-center gap-2">
    🛒 Shopping from:{' '}
    <Link 
      to={cartSource.type === 'hub' ? `/hub/${cartSource.slug || cartSource.id}` : `/producer/${cartSource.slug || cartSource.id}`}
      className="font-bold underline hover:text-blue-900"
    >
      {cartSource.name || (cartSource.type === 'hub' ? 'Hub' : 'Producer')}
    </Link>
    <HelpTooltip message="You can only purchase from one vendor at a time. Clear your cart to shop elsewhere." />
  </p>
  <p className="text-xs text-blue-600 mt-1">
    You can only purchase products from this vendor in this cart.
  </p>
</div>

      )}
      
      <div className="bg-white rounded-lg shadow-md overflow-hidden">
        <div className="divide-y divide-gray-200">
          {cartItems.map((item) => (
            <div key={item.productId} className="p-4 flex flex-col sm:flex-row justify-between items-center gap-4">
              {/* Product thumbnail */}
              <div className="flex items-center gap-3 flex-1">
                {item.images && item.images[0] && (
                  <img 
                    src={`/uploads/${item.images[0]}`} 
                    alt={item.name} 
                    className="w-12 h-12 object-cover rounded"
                    onError={(e) => e.target.style.display = 'none'}
                  />
                )}
                <div>
                  <h3 className="font-semibold text-lg">{item.name}</h3>
                  <p className="text-gray-500 text-sm">${item.price}/{item.unit}</p>
                </div>
              </div>
              
              {/* Quantity dropdown */}
              <div className="flex items-center gap-3">
                <label className="text-gray-600">Qty:</label>
                <select
                  value={item.quantity}
                  onChange={(e) => updateQuantity(item.productId, parseInt(e.target.value))}
                  className="border rounded px-2 py-1 w-20"
                >
                  {[1,2,3,4,5,6,7,8,9,10].map(num => (
                    <option key={num} value={num}>{num}</option>
                  ))}
                </select>
              </div>
              
              <div className="w-32 text-right">
                <span className="font-semibold">${(item.price * item.quantity).toFixed(2)}</span>
              </div>
              <button
                onClick={() => removeFromCart(item.productId)}
                className="text-red-500 hover:text-red-700"
              >
                Remove
              </button>
            </div>
          ))}
        </div>
        
        <div className="bg-gray-50 p-4 border-t">
          <div className="flex justify-between mb-4">
            <span className="text-lg font-semibold">Total:</span>
            <span className="text-xl font-bold text-green-600">${getCartTotal().toFixed(2)}</span>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-3 justify-between">
            <div className="flex gap-3">
              {cartSource && (
                <Link
                  to={cartSource.type === 'hub' ? `/hub/${cartSource.slug || cartSource.id}` : `/producer/${cartSource.slug || cartSource.id}`}
                  className="bg-gray-200 text-gray-700 px-4 py-2 rounded hover:bg-gray-300 text-center"
                >
                  ← Continue Shopping at {cartSource.name || (cartSource.type === 'hub' ? 'Hub' : 'Producer')}
                </Link>
              )}
              {!cartSource && (
                <Link to="/products" className="bg-gray-200 text-gray-700 px-4 py-2 rounded hover:bg-gray-300">
                  ← Continue Shopping
                </Link>
              )}
              <button
                onClick={() => {
                  if (window.confirm('Clear all items from your cart?')) {
                    clearCart();
                  }
                }}
                className="text-red-600 hover:text-red-800"
              >
                Clear Cart
              </button>
            </div>
            {user && cartSource && user._id !== cartSource.id && (
              <button
                onClick={handleCheckout}
                className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700"
              >
                Proceed to Checkout
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
